import { onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function ConsoleBugReportsRoute() {
  const navigate = useNavigate();
  onMount(() => {
    navigate("/console/super-admin/signalements", { replace: true });
  });
  return null;
}
